import axios from "axios";
import React, { useEffect, useState } from "react";
import { Badge, Button, Checkbox, Col, Collapse, Row, Skeleton, Typography } from "antd";
import { EventType } from "@bindeleddet/core/types";
import { StyledCard } from "./style";
import { Sector } from "./interface";

const { Title, Text } = Typography;
const { Panel } = Collapse;

interface Props {
  toggleCheckedSectors: (id: number) => void;
  sectorsChecked: number[];
  toggleCheckedTypes: (id: number) => void;
  typesChecked: number[];
  onFilterReset: () => void;
}

const EventFilter: React.FC<Props> = ({
  toggleCheckedSectors,
  sectorsChecked,
  toggleCheckedTypes,
  typesChecked,
  onFilterReset,
}) => {
  const [sectors, setSectors] = useState<Sector[]>([]);
  const [eventTypes, setEventTypes] = useState<EventType[]>([]);

  useEffect(() => {
    axios.get<Sector[]>("/companies/sectors/").then(response => {
      setSectors(response.data);
    });
    axios.get<EventType[]>("/events/event-types/").then(response => {
      setEventTypes(response.data);
    });
  }, []);

  const AxiosSectors = sectors.map(sector => {
    if (!sector.name) return null;
    const isChecked = sectorsChecked.includes(sector.id);
    return (
      <Col xs={12} sm={6} md={24} key={sector.id}>
        <Checkbox checked={isChecked} onChange={() => toggleCheckedSectors(sector.id)} value={isChecked}>
          <Text>{sector.name}</Text>
        </Checkbox>
      </Col>
    );
  });

  const AxiosTypes = eventTypes.map(eventType => {
    if (!eventType.title) return null;
    const isChecked = typesChecked.includes(eventType.id);
    return (
      <Col xs={12} sm={6} md={24} key={eventType.id}>
        <Checkbox checked={isChecked} onChange={() => toggleCheckedTypes(eventType.id)} value={isChecked}>
          <Text>{eventType.title}</Text>
        </Checkbox>
      </Col>
    );
  });

  return (
    <>
      <StyledCard bodyStyle={{ padding: "2em" }}>
        <Collapse ghost expandIconPosition="end">
          <Panel
            header={
              <Badge color="#91CA91" dot={typesChecked.length > 0}>
                <Title level={5}>Type</Title>
              </Badge>
            }
            key="type"
          >
            <Row>{eventTypes.length ? AxiosTypes : <Skeleton active />}</Row>
          </Panel>
          <Panel
            header={
              <Badge color="#91CA91" dot={sectorsChecked.length > 0}>
                <Title level={5}>Bransje</Title>
              </Badge>
            }
            key="sector"
          >
            <Row>{sectors.length ? AxiosSectors : <Skeleton active />}</Row>
          </Panel>
        </Collapse>
        <Row style={{ paddingTop: "2em" }} justify="center">
          <Button danger block onClick={onFilterReset}>
            Nullstill filtrering
          </Button>
        </Row>
      </StyledCard>
    </>
  );
};

export default EventFilter;
